import * as React from 'react';

function SvgValetPin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={38} height={45} viewBox="0 0 38 45" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#2F2D78"
          d="M0 2v27.758a.5.5 0 00.19.393L19 45l18.81-14.85a.5.5 0 00.19-.392V2a2 2 0 00-2-2H2a2 2 0 00-2 2z"
        />
        <path
          fill="#5F59FF"
          d="M.5 2v27.092a.5.5 0 00.19.392L19 44l18.31-14.516a.5.5 0 00.19-.392V2a2 2 0 00-2-2h-33a2 2 0 00-2 2z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M25.638 22.287l-4.33 4.331H20.23a1.524 1.524 0 00.07-1.837l2.494-2.494a2.009 2.009 0 012.844 0zm3.968-.484c0 .258-.1.515-.295.711l-4.104 4.104h-2.844l5.525-5.524a1.008 1.008 0 011.718.709z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M32.407 23.197c0 .278-.106.555-.317.767l-4.593 4.608a5.168 5.168 0 01-2.676 1.423l-7.705 1.485a7.692 7.692 0 00-4.857 3.05l-5.573-4.286c.709-.707 1.467-1.64 1.577-2.478.207-1.593 1.555-3.053 4.178-3.117h6.448a1.004 1.004 0 011.006 1.006c0 .459-.306.844-.724.965h-4.582a.321.321 0 00-.31.24c-.005.02-.01.04-.01.06v.02a.31.31 0 00.11.24c.058.05.133.081.214.081h11.144l4.829-4.833a1.08 1.08 0 011.528 0c.207.214.313.492.313.77zM19.725 4.406a3.776 3.776 0 00-.967 7.425v2.306l.66.932-.66.932v.053l.66.931-.66.932v.007l1.022 2.914.987-1.128v-7.9a3.774 3.774 0 00-1.042-7.403zm0 3.636a1.195 1.195 0 010-2.388 1.195 1.195 0 010 2.388z"
        />
      </g>
    </svg>
  );
}

export default SvgValetPin;
